import { PATH } from '../../../constants/router'
import { encodeLink, getAllUrlParams } from '../../../helper/params'
import { checkShowPaymentMethodWithTheme } from '../../../helper/paymentMethod'

export default class BasePartner {
  usePaymentPageEffect({ location, setErrorMessage }) {
    // Không làm gì mặc định
  }

  getPaymentMethodApiPayload({ apikey }) {
    return {}
  }

  processPaymentMethods(methods, currentPaymentMethodType, appThemeName) {
    let filteredData = methods
    if (currentPaymentMethodType) {
      filteredData = filteredData.filter((item) => item.paymentMethodType === currentPaymentMethodType)
    } else {
      filteredData = checkShowPaymentMethodWithTheme(filteredData, appThemeName)
    }
    
    return {
      filteredData,
      initialMethod: filteredData.length > 0 ? filteredData[0] : null
    }
  }

  getAllowRenew() {
    return 0
  }

  getCreateOrderPaymentMethodData(paymentMethodData) {
    return {
      paymentMethodId: paymentMethodData?.paymentMethodId,
      paymentMethodType: paymentMethodData?.paymentMethodType
    }
  }

  getCreatePaymentMethodData(paymentMethodData, orderDetail) {
    return {
      paymentMethodId: paymentMethodData?.paymentMethodId ?? orderDetail?.paymentMethodId,
      paymentMethodType: paymentMethodData?.paymentMethodType ?? orderDetail?.paymentMethodType
    }
  }

  getRedirectUrls(orderId, phoneNumber) {
    const currentParamsObj = getAllUrlParams()

    if (phoneNumber) {
      currentParamsObj.sdkPhoneNumber = phoneNumber
    }

    const redirectDataObj = {
      redirectUrl: PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT,
      params: currentParamsObj
    }

    const encodedRedirectData = encodeLink(JSON.stringify(redirectDataObj))

    const cancelDataObj = {
      redirectUrl: PATH.TRAFFIC_FINE_VEHICLES,
      params: currentParamsObj
    }

    const encodedCancelData = encodeLink(JSON.stringify(cancelDataObj))

    const returnPath = `${PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT_SUCCESS}?redirectData=${encodedRedirectData}&orderIdSuccess={{orderId}}`
    const cancelPath = `${PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_REDIRECT_HANDLER}?redirectData=${encodedCancelData}`

    return { returnPath, cancelPath }
  }

  async beforePayment({ orderId, phoneNumber, setIsSubmitting, setErrorMessage, redirectToExternalPayment }) {
    return true
  }

  handlePostPaymentResponse({ paymentResponse, setIsSubmitting, redirectToExternalPayment, setErrorMessage }) {
    const paymentLink = paymentResponse?.data?.paymentLinkUrl
    
    if (typeof paymentLink === 'string' && paymentLink.startsWith('https://')) {
      redirectToExternalPayment(paymentLink)
      return { handled: true }
    }
    
    return { handled: false }
  }
}
